module.exports = __webpack_public_path__ + "static/img/physical_harm_4.4165427a.png";